// @ts-check
/**
 * @prettier
 */

import _orderBy from 'lodash/orderBy';

/**
 * Gets an image from the draft
 * @param {Object} draft
 * @param {Array<{ catalog_item_view: { image_urls: { raw_plp?: string, thumbnail?: string } } }>} draft.customizations
 * @return {string}
 */
const getImageFromDraft = ({ customizations }) => {
  const { raw_plp: plp, thumbnail } = _orderBy(
    customizations,
    'lead',
    'desc'
  )[0].catalog_item_view.image_urls;
  if (plp) return plp;
  return thumbnail;
};

export default getImageFromDraft;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/ExistingDraftsForCardSuiteModal/tools/getImageFromDraft.js